import { GameService } from "./game";
import { RegionService } from "./regions";
import { StorageService } from "./storage";
import { UIService } from "./ui";


async function main(): Promise<void> {
  // Create dependancy services
  const regionService = new RegionService();
  const storageService = new StorageService();
  const uiService = new UIService(regionService, storageService);

  // Create and initialise Game
  const gameService = new GameService(regionService, storageService, uiService);
  await gameService.init();

  // Check for new day every minute
  setInterval(() => {
    gameService.checkNewDay();
  }, 60000);
}


// Initialize game when DOM is loaded
document.addEventListener('DOMContentLoaded', async () => await main());
